import React from "react";
import { HiOutlineDownload } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import OptionToggleRow from "./OptionToggleRow";

interface SaveContactToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  title?: string;
  description?: string;
}

const SaveContactToggle: React.FC<SaveContactToggleProps> = ({
  enabled,
  onChange,
  title,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <OptionToggleRow
      icon={HiOutlineDownload}
      iconClassName="text-green-600"
      title={title ?? t("businessCardPage.optionsTab.saveContactTitle")}
      description={
        description ??
        t("permissions.businessCard.saveContact.enableGloballyDescription")
      }
      enabled={enabled}
      onChange={onChange}
    />
  );
};

export default SaveContactToggle;
